import React, { useCallback, ChangeEvent } from 'react'

const PLAFOND_PATTERN = /^((\d+(\.\d?)?|\.\d+)%?)?$/

interface PlafondInputProps {
    value: string | number | null | undefined
    onChange: (value: string | number) => void
}

const PlafondInput: React.FC<PlafondInputProps> = ({ value, onChange }) => {
    const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value

        if (!PLAFOND_PATTERN.test(newValue)) {
            return
        }

        const numericValue = Number(newValue) > 100 ? 100 : newValue
        onChange(numericValue)
    }, [onChange])

    return (
        <>
            <input
                type="text"
                onChange={handleChange}
                value={value ?? ""}
                style={{ width: '5em' }}
            /> %
        </>
    )
}

export default PlafondInput
